export const publishConstant = {
    SEARCH_QUESTION_SUCCESS: 'SEARCH_QUESTION_SUCCESS',
    SELECTED_FILTERS: 'SELECTED_FILTERS',
    FILTERS: 'FILTERS',
    FETCH_SOLUTION_TEXT: 'FETCH_SOLUTION_TEXT'
};
